









































































import { Vue, Component, Watch } from 'vue-property-decorator';
import PreviewSection from '@/components/PreviewSection/index.vue';
import API from '@/controllers/api';
import * as APITypes from '@/controllers/api/types';
import * as Global from '@/global';
import * as Error from '@/utils/errors';

@Component({ components: { PreviewSection } })
export default class UserPreview extends Vue {
  private isFetching: boolean = true;
  private user: APITypes.ExtendedUser | null = null;
  private error: Global.AppError | null = null;
  private repositories: APITypes.Repository[] = [];
  private repositoriesFetching: boolean = false;
  private followers: APITypes.User[] = [];
  private followersFetching: boolean = false;
  private followed: APITypes.User[] = [];
  private followedFetching: boolean = false;
  private repoSortOptions: string[] = Global.userRepoSortOptions;

  private get username(): string {
    return this.$route.params.name;
  }

  private async loadUser(): Promise<void> {
    try {
      this.user = await API.getUser(this.username);
    } catch (error) {
      if (error?.status === 404) this.error = Error.NotFound('User');
      else if (error?.status === 403) this.error = Error.LimitExceeded();
      else this.error = Error.UnexpectedError();
    }
  }

  private async loadRepos(params: APITypes.FindItemParams): Promise<void> {
    try {
      this.repositoriesFetching = true;
      this.repositories = await API.getUserRepositories(this.username, params);
    } catch (error) {
      if (error?.status === 403) this.error = Error.LimitExceeded();
      else this.error = Error.UnexpectedError();
    } finally {
      this.repositoriesFetching = false;
    }
  }

  private async loadFollowers(params: APITypes.FindItemParams): Promise<void> {
    try {
      this.followersFetching = true;
      this.followers = await API.getUserFollowers(this.username, params);
    } catch (error) {
      if (error?.status === 403) this.error = Error.LimitExceeded();
      else this.error = Error.UnexpectedError();
    } finally {
      this.followersFetching = false;
    }
  }

  private async loadFollowed(params: APITypes.FindItemParams): Promise<void> {
    try {
      this.followedFetching = true;
      this.followed = await API.getFollowedByUser(this.username, params);
    } catch (error) {
      if (error?.status === 403) this.error = Error.LimitExceeded();
      else this.error = Error.UnexpectedError();
    } finally {
      this.followedFetching = false;
    }
  }

  private async loadData(): Promise<void> {
    this.isFetching = true;
    await this.loadUser();
    await this.loadRepos(Global.defaultRepoRequestParams);
    await this.loadFollowers(Global.defaultUserRequestParams);
    await this.loadFollowed(Global.defaultUserRequestParams);
    this.isFetching = false;
  }

  @Watch('$route.fullPath')
  private async handleUserChange(): Promise<void> {
    await this.loadData();
  }

  async mounted(): Promise<void> {
    await this.loadData();
  }
}
